// extracted by mini-css-extract-plugin
module.exports = {"icon":"ShareButton_icon__GmJEN","isHidden":"ShareButton_isHidden__2KJcQ"};